import store, { modulesName } from '@/store';

//constants
import roles from '@/utils/constants/roles.js';
import langTypes from '@/utils/constants/lang.js';

export const userMixin = {
  computed: {
    userAuthenticated() {
      return store.getters[`${modulesName.userModuleName}/isLoggedIn`];
    },
    userId() {
      return store.getters[`${modulesName.userModuleName}/userId`];
    },
    userRole() {
      return store.getters[`${modulesName.userModuleName}/role`];
    },
    isUserRoleApplicant() {
      return (
        store.getters[`${modulesName.userModuleName}/role`] === roles.APPLICANT
      );
    },
    isUserRoleSupervisor() {
      return (
        store.getters[`${modulesName.userModuleName}/role`] === roles.SUPERVISOR
      );
    },
    isUserRoleInvestigator() {
      return (
        store.getters[`${modulesName.userModuleName}/role`] === roles.INVESTIGATOR
      );
    },
    userFullName() {
      return store.getters[`${modulesName.userModuleName}/fullName`];
    },
    userMainCompany() {
      return store.getters[`${modulesName.userModuleName}/mainCompany`];
    },
    userSelectedLang() {
      return this.$i18n.locale || langTypes.ES;
    },
    isEnLang() {
      return this.userSelectedLang === langTypes.EN;
    },
  },
  methods: {
    userHasPermissions() {
      return true;
      // return store.getters[`${modulesName.userModuleName}/hasPermissions`](
      //   permissions
      // );
    },
  },
};
